export interface Role {
  id: number;
  name: RoleEnum;
}

export enum RoleEnum {
  ADMIN = "ADMIN",
  SUPERVISOR = "SUPERVISOR",
  OPERATOR = "OPERATOR",
}
